export default __webpack_public_path__ + "static/media/x-white-outline.affecefe.svg";